module.exports = "https://www.gc-pro.gnp.com.mx/3f1315a06b6623a8ad20b7da94a1cab1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/seguridad-icono.svg
// module id = 8165
// module chunks = 0